import React from "react";
import "./PartyGalleryOn.css";

function PartyGalleryOn(props) {
  const { children } = props;

  return (
    <div className="party-gallery-on">
      <div className="party-makeup-9 poppins-medium-white-10px">{children}</div>
    </div>
  );
}

export default PartyGalleryOn;
